import { render, staticRenderFns } from "./InvoiceApproveBtns.vue?vue&type=template&id=10b4c156&"
import script from "./InvoiceApproveBtns.vue?vue&type=script&lang=js&"
export * from "./InvoiceApproveBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports